const baseField =
  "w-full border-[3px] border-ink bg-cream px-4 py-3 text-base text-ink placeholder:text-ink/40 transition-shadow duration-200 focus:outline-none focus:shadow-[4px_4px_0_#111]";

export const Label = ({ children, htmlFor }) => (
  <label htmlFor={htmlFor} className="block text-xs font-bold uppercase tracking-[0.2em] mb-2 text-ink">
    {children}
  </label>
);

export const Input = ({ className = "", ...props }) => (
  <input {...props} className={`${baseField} ${className}`} />
);

export const TextArea = ({ className = "", ...props }) => (
  <textarea {...props} className={`${baseField} ${className}`} rows={5} />
);

export const Select = ({ className = "", children, ...props }) => (
  <select {...props} className={`${baseField} appearance-none ${className}`}>
    {children}
  </select>
);

export default { Label, Input, TextArea, Select };
